import { Logger, LoggerService } from '@Shared/logger';
import { UIModule } from '../ui.module';
import { Template } from './template';

export class InlineTemplate extends Template {
  private Logger: Logger = LoggerService.createLogger('InlineTemplate');

  private selector: string;

  constructor(_selector: string) {
    super();
    this.selector = _selector;
    this.html = UIModule.HTML.inline;
    this.Logger.trace('****  CTOR ****');
  }

  public showTemplate(): void {
    this.Logger.trace('showTemplate', 'InlineTemplate');
  }

  public closeTemplate(): void {
    throw new Error('Method not implemented.');
  }

  protected renderTemplate(): void {}

  public renderBaseTemplate(): void {
    super.renderBaseTemplate();
    this.Logger.trace('renderTemplate');
    const target = document.querySelector(this.selector);
    if (target) {
      target.appendChild(this.container);
    } else {
      this.Logger.error(
        `Inline container not found for selector: ${this.selector}`,
      );
      // Fallback: append to body.
      document.body.appendChild(this.container);
    }
  }
}
